var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.518,
    height: 22.546,
    viewBox: "0 0 22.518 22.546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8239",
    "data-name": "Group 8239",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8238",
    "data-name": "Group 8238",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16839",
    "data-name": "Path 16839",
    d: "M5257.5,2018.457l.9-3.276c.213-.774.434-1.546.631-2.323a.617.617,0,0,0-.074-.4,11.14,11.14,0,0,1,3.6-14.6,11.109,11.109,0,0,1,13.856,1.023,10.872,10.872,0,0,1,3.561,9.186,11.252,11.252,0,0,1-16.285,8.983.783.783,0,0,0-.5-.06c-1.75.442-3.5.9-5.245,1.354C5257.818,2018.38,5257.689,2018.41,5257.5,2018.457Zm2.711-2.7c.2-.045.317-.068.435-.1.939-.242,1.875-.5,2.819-.72a.777.777,0,0,1,.517.085,9.333,9.333,0,0,0,13.6-11.112,9.324,9.324,0,0,0-12.22-5.472,9.421,9.421,0,0,0-5.865,8.339,9.262,9.262,0,0,0,1.471,5.3.717.717,0,0,1,.121.454c-.059.338-.177.667-.269,1C5260.619,2014.247,5260.423,2014.964,5260.207,2015.752Z",
    transform: "translate(-5257.495 -1995.911)",
    fill: "#7e97b8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16840",
    "data-name": "Path 16840",
    d: "M5295.439,2034.155c.478-.112.713.163.878.588.256.654.537,1.3.815,1.943a.62.62,0,0,1-.059.663c-.207.276-.41.556-.634.818a.5.5,0,0,0-.049.664,7.711,7.711,0,0,0,3.7,3.221.574.574,0,0,0,.787-.189c.238-.323.512-.62.751-.942a.428.428,0,0,1,.553-.176c.371.151.733.323,1.1.481s.709.309,1.069.447a.577.577,0,0,1,.422.631,2.417,2.417,0,0,1-2.266,2.318,5.257,5.257,0,0,1-2.815-.566,10.337,10.337,0,0,1-4.339-3.314,9.788,9.788,0,0,1-1.7-2.592,3.256,3.256,0,0,1,.449-3.375A1.33,1.33,0,0,1,5295.439,2034.155Z",
    transform: "translate(-5287.764 -2028.151)",
    fill: "#7e97b8",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatsapp);
export default __webpack_public_path__ + "static/media/watsapp.8ea8fbf408b8f9d8bbe73b680e6d976c.svg";
export { ForwardRef as ReactComponent };